import { render, staticRenderFns } from "./Mycollection.vue?vue&type=template&id=d6ecfe5e&scoped=true"
import script from "./Mycollection.vue?vue&type=script&lang=js"
export * from "./Mycollection.vue?vue&type=script&lang=js"
import style0 from "./Mycollection.vue?vue&type=style&index=0&id=d6ecfe5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ecfe5e",
  null
  
)

export default component.exports